import { InventoryItemContainerProps } from "../../pages/character/components/InventoryItemSlot/InventoryItemContainer";
import { createContext } from "react";

export type InventoryItemTransferContextValues = {
    transferTargetItemContainer: InventoryItemContainerProps | null;
    setTransferTargetItemContainer: (
        itemContainer: InventoryItemContainerProps | null
    ) => void;
};

export const DefaultInventoryItemTransferContextValue: InventoryItemTransferContextValues =
    {
        transferTargetItemContainer: null,
        setTransferTargetItemContainer: (_) => {},
    };

const InventoryItemTransferContext =
    createContext<InventoryItemTransferContextValues>(
        DefaultInventoryItemTransferContextValue
    );

export default InventoryItemTransferContext;
